// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__L0vzj","hand":"Home_hand__4+-Em","wave":"Home_wave__X-XBO"};